class Panels extends HTMLElement {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.querySelectorAll('[data-tab-panels-el="trigger"]').forEach(element => {
      element.addEventListener('click', this.handleTriggerClick.bind(this))
    })
  }

  handleTriggerClick (event) {
    const activeTrigger = event.currentTarget.dataset.tabPanelTriggerLabel
    const panels = this.querySelectorAll('[data-tab-panels-el="view"]')

    this.querySelectorAll('[data-tab-panels-el="trigger"]').forEach(trigger => {
      const connection = trigger.dataset.tabPanelTriggerLabel
      event.currentTarget.dataset.tabPanelTriggerLabel === connection
        ? trigger.setAttribute('aria-selected', 'true')
        : trigger.setAttribute('aria-selected', 'false')
    })

    panels.forEach(panel => {
      panel.dataset.tabPanelView === activeTrigger
        ? panel.setAttribute('aria-hidden', 'false')
        : panel.setAttribute('aria-hidden', 'true')
    })
  }
}

if (!customElements.get('tab-panels')) {
  customElements.define('tab-panels', Panels)
}
